import { useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import { toast } from "react-toastify";
import { ButtonSkeleton } from "./CalendarComponents/SkeletonLoader.jsx";
import crossImage from "../../images/singleinvoice/cross-red.svg";

const RejectTimeOffModal = ({ isRejectModalOpen, setIsRejectModalOpen, setModalIsOpen, timeOffId, token, refetchLeaves }) => {
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);

    const handleConfirmReject = async () => {
        if (!timeOffId) return;
        try {
            setIsSubmitLoading(true);
            await axios.get(`/api/time-off-request/reject/${timeOffId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success("Time Off Request rejected successfully!", {
                position: "bottom-right",
                autoClose: 2000,
            });
            setModalIsOpen(false);
            handleCancelReject();
            refetchLeaves();
        } catch (error) {
            console.error("Rejection error:", error);
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleCancelReject = () => {
        setIsRejectModalOpen(false);
        document.body.classList.remove("ReactModal__Body--open");
    };

    return (
        <Modal
            className="center-modal"
            isOpen={isRejectModalOpen}
            onRequestClose={handleCancelReject}
            contentLabel="Confirm Reject"
            style={{
                content: {
                    width: "300px",
                    height: "200px",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    borderRadius: "12px",
                    background: "#fff",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                    border: "none",
                },
                overlay: {
                    backgroundColor: "rgba(0,0,0,0.5)",
                },
            }}
        >
            <div className="delete-modal-content">
                <h2>Confirm Reject</h2>
                <p>Are you sure you want to Reject this Time Off Request?</p>
                <div className="delete-modal-buttons">
                    <button
                        className="modal-btn modal-btn-calendar reject"
                        onClick={handleConfirmReject}
                        disabled={isSubmitLoading}
                    >
                        {isSubmitLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                <ButtonSkeleton width="70px" height="18px" />
                            </div>
                        ) : (
                            <span className="approve-btn-content approve-btn-content-space">
                                Reject
                                <img src={crossImage} alt="Reject" />
                            </span>
                        )}
                    </button>
                    <button
                        className="modal-btn modal-btn-calendar cancel"
                        onClick={handleCancelReject}
                        disabled={isSubmitLoading}
                    >
                        {isSubmitLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                <ButtonSkeleton width="60px" height="18px" />
                            </div>
                        ) : (
                            "Cancel"
                        )}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default RejectTimeOffModal;